import React from 'react'
import useUserPermission from '../../../../hooks/useUserPermission'
import PageHeading from '../../../molecules/PageHeading'
import InstitutionFilter from '../../../organisms/filters/InstitutionFilter'
import useSearchParams from '../../../../hooks/useSearchParams'
import { isPCM } from '../../../../hooks/useInstitution'
import OfficeHoursForm from '../../../organisms/office_hours/OfficeHoursForm'
import OfficeHoursViewer from '../../../organisms/office_hours/OfficeHoursViewer'
import { getPageDescription } from '../../../../configs/officeHourConfig'

const OfficeHours = () => {
  const searchParams = useSearchParams()
  const institutionId = searchParams.get('institution_id')
  const { canFilterByInstitution } = useUserPermission('user')
  const pageDescription = getPageDescription({ canFilterByInstitution })
  const isPCMSelected = isPCM({ id: parseInt(institutionId) })

  return (
    <>
      <PageHeading
        title="Horario de atención"
        pageDescription={pageDescription}
        filterSection={
          <div className="flex-col md:flex-row flex w-full items-baseline md:gap-2 gap-4">
            {canFilterByInstitution && <InstitutionFilter />}
          </div>
        }
      />
      {canFilterByInstitution && !isPCMSelected ? (
        <OfficeHoursViewer institutionId={institutionId} />
      ) : (
        <OfficeHoursForm />
      )}
    </>
  )
}

export default OfficeHours
